import axios from '../../axios'

/*
 * 准考证号规则数据接口
 */

// 获取准考证号规则列表
export const getRuleList = (data) => {
    return axios({
        url: '/api/mock/aff/rule',
        method: 'get',
        data
    })
}

// 新增准考证号规则信息
export const saveRule = (data) => {
    return axios({
        url: '/api/mock/aff/rule',
        method: 'post',
        data
    })
}

// 编辑准考证号规则信息
export const updateRule = (data) => {
    return axios({
        url: '/api/mock/aff/rule',
        method: 'put',
        data
    })
}

// 删除准考证号规则列表
export const deleteRule = (data) => {
    return axios({
        url: '/api/mock/aff/rule ',
        method: 'delete',
        data
    })
}


// 批量删除准考证号规则列表
export const deleteRuleBatch = (data) => {
    return axios({
        url: '/api/mock/aff/delete_batch_rule ',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/aff/rule.js